export const DIRECT_TRANSACTION_METADATA_KEY = `__tanstack_db_direct`
